/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EquipmentScheduleAssignmentItemResponseDto } from './equipment-schedule-assignment-item-response-dto';


export interface EquipmentSchedulesByEquipmentResponseDto { 
    equipmentId?: string;
    regular?: EquipmentScheduleAssignmentItemResponseDto;
    calendars?: Array<EquipmentScheduleAssignmentItemResponseDto> | null;
}

